import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      redirect: "/index",
      component: () => import("@/view/layout/index"),
      children: [
        {
          path: "/index",
          name: "index",
          component: () => import("@/view/home/index"),
          meta: {
            show: true,
            title: "首页",
            typeId: "0",
            name:
              "「深圳市物网通科技有限公司」提供专业的软件开发定制及外包服务",
            keywords:
              "深圳市软件公司，软件开发，软件外包公司，软件开发公司，外包服务公司，企业信息化管理，软件定制开发，app开发，共享经济解决方案",
            description:
              "深圳市物网通科技有限公司在软件开发及外包服务领域，是一家充满创新精神的软件公司。是一家专注于app开发，商城app开发，app定制开发，软件开发，小程序开发以及共享单车,滑板车,电器,充电线,智能回收系统,网约车,社区团购等物联网智能软硬件开发方案。公司致力革新信息化管理系统解决方案，是中小型软件外包服务诚信承接方、智能硬件开发,软件开发定制,物联网平台开发,网站开发,物联网解决方案,智能化方案提供商,从事互联网技术,企业办公系统（OA/CRM/ERP）物联网技术,数据技术在人工智能,物联网,工业4.0,交通，典型案例包括智能家居、智能家电、物联网传感云、共享经济，为中小企业提供智能硬件解决方案、物联网解决方案、智能硬件方案定制等服务，是国内领先的物联网解决方案公司"
          }
        },
        // {
        //   path: "/service",
        //   name: "service",
        //   component: () => import("@/view/service/index")
        // },
        // {
        //   path: "/serviceDetails",
        //   name: "serviceDetails",
        //   component: () => import("@/view/serviceDetails/index")
        // },
        // {
        //   path: "/case",
        //   name: "case",
        //   component: () => import("@/view/case/index")
        // },
        // {
        //   path: "/caseDetails",
        //   name: "caseDetails",
        //   component: () => import("@/view/caseDetails/index")
        // },
        // {
        //   path: "/solution",
        //   name: "solution",
        //   component: () => import("@/view/solution/index")
        // },
        {
          path: "/news",
          name: "news",
          component: () => import("@/view/news/index"),
          meta: {
            show: true,
            title: "新闻中心",
            typeId: "6",
            name:
              "小程序开发资讯_APP开发新闻_网站建设资讯_「深圳市物网通科技有限公司」",
            keywords: "",
            description:
              "小程序开发资讯，APP开发资讯，网站建设资讯，微信开发资讯，为您提供微信小程序开发、APP开发、微信开发、品牌官网网站建设、电商系统等最新行业相关资讯。。「深圳市物网通科技有限公司」"
          }
        },
        {
          path: "/about",
          name: "about",
          component: () => import("@/view/about/index"),
          meta: {
            show: true,
            title: "公司介绍",
            typeId: "6",
            name: "关于我们_「深圳市物网通科技有限公司」",
            keywords: "关于我们",
            description:
              "深圳市物网通科技有限公司成立于2019年，是一家专注于提供移动互联网+智能硬件的一体化解决方案提供商，作为国内专业的共享经济创新模式与物联网服务提供商，专业提供共享经济整体解决方案与物联网智能硬件一站式开发服务，包括APP定制开发、政府系统开发、智能硬件、物联网、景区单车、共享经济等开发服务。从客户项目的需求分析，到立项计划制定，再到功能开发与交付，产品测试与专业售后服务等，致力于为客户打造满意的物联网产品。同创将坚持以“专注物联网整体解决方案”的企业发展战略，开启物联网新模式，提高产品质量，公司秉承对客户负责的原则，注重应用落地并积极跟进，主动解决售后问题，让客户能更好的着力于运营，助力客户快速发展，携手共赢。「深圳市物网通科技有限公司」"
          }
        },
        {
          path: "/contactUs",
          name: "contactUs",
          component: () => import("@/view/contactUs/index"),
          meta: {
            show: true,
            title: "联系我们",
            typeId: "6",
            name: "联系我们_「深圳市物网通科技有限公司」",
            keywords: "同创科技",
            description:
              '专业靠谱的技术伙伴,为企业提供一站式技术服务，同创热线中心秉承"感动常在"的宗旨,诚心诚意为顾客提供专业、优质的服务。办公地址：深圳市龙华区龙华街道雪岗北路308号恒博利荣丰产业园C1011，联系方式18123617975「深圳市物网通科技有限公司」'
          }
        },
        {
          path: "/newsDetails",
          name: "newsDetails",
          component: () => import("@/view/newsDetails/index"),
          meta: {
            show: false,
            title: "新闻详情",
            typeId: "6",
            name: "「深圳市物网通科技有限公司」",
            keywords: "",
            description: "「深圳市物网通科技有限公司」"
          }
        },
        {
          path: "/bicycle",
          name: "bicycle",
          component: () => import("@/view/bicycle/index"),
          meta: {
            show: true,
            title: "共享单车",
            typeId: "1",
            name:
              "共享单车解决方案_通过APP+单车+智能锁+电子围栏_专注共享系统解决方案「深圳市物网通科技有限公司」",
            keywords: "共享单车解决方案",
            description:
              "共享单车 共享单车解决方案其中包含共享单车锁，共享单车APP研发，公共自行车，gps锁，智能单车锁，集多种优势与一身，适用场景，景区，学校，城区，校园全方面应用场景，提供一站式整体解决方案「深圳市物网通科技有限公司」"
          }
        },
        {
          path: "/scooter",
          name: "scooter",
          component: () => import("@/view/scooter/index"),
          meta: {
            show: true,
            title: "共享滑板车",
            typeId: "1",
            name:
              "共享电动滑板车_共享滑板车锁桩_滑板车自助租赁系统一站式解决方案「深圳市物网通科技有限公司」",
            keywords: "共享滑板车",
            description:
              "共享滑板车系统是基于物联网技术，，实现无人租赁，我们将提供一站式共享方案解决方案：共享电动滑板车IoT定位通讯主控盒，能提供4G通信，电控系统，可采用有桩RFID也可采用蓝牙道钉定点取还车，智能断电控制器有报警器功能、位置查询功能、记录功能的新型智能控制器，成熟后台管理省去您开发成本「深圳市物网通科技有限公司」"
          }
        },
        {
          path: "/companionBed",
          name: "companionBed",
          component: () => import("@/view/companionBed/index"),
          meta: {
            show: true,
            title: "共享陪护床",
            typeId: "1",
            name:
              "共享陪护床_陪护椅智能锁_自助租赁系统一站式解决方案「深圳市物网通科技有限公司」",
            keywords: "共享陪护床",
            description:
              "专业医院共享陪护床整体解决方案服务商,提供蓝牙和NB智能锁的研发，共享陪护床智能锁，共享陪护椅智能锁，共享陪护床小程序系统开发，智能硬件开发+共享APP/小程序系统开发,自助扫码租赁,实现共享陪护床智能化管理。共享陪护床和共享陪护椅设备供应的科技型企业，成熟后台管理省去您开发成本「深圳市物网通科技有限公司」"
          }
        },
        {
          path: "/electricCar",
          name: "electricCar",
          component: () => import("@/view/electricCar/index"),
          meta: {
            show: true,
            title: "共享电动车",
            typeId: "1",
            name:
              "共享电池电动车_共享出行_无人租赁系统一站式解决方案「深圳市物网通科技有限公司」",
            keywords: "共享电动车",
            description:
              "专注于电动车的智能定位硬件及位置服务平台的打造，覆盖行业有：共享电动车，共享电池，共享运营平台等，公司已经自主研发了涵盖智能硬件、智能出行平台、出行APP的智能出行解决方案并得到了市场的高度认可，成熟后台管理省去您开发成本，软硬件整体解决方案!共享电动车系统,源码开发,按需定制更专业!「深圳市物网通科技有限公司」"
          }
        },
        {
          path: "/chargingPile",
          name: "chargingPile",
          component: () => import("@/view/chargingPile/index"),
          meta: {
            show: true,
            title: "智能充电桩整体解决方案",
            typeId: "2",
            name: "小区充电站|智能充电桩一站式解决方案「深圳市物网通科技有限公司」",
            keywords: "智能充电桩",
            description:
              "深圳市物网通科技有限公司一站式综合服务商。 主要对电动车、智能充电桩、电动车充电桩、小区充电桩、汽车充电桩、电瓶车充电桩，充电桩及互联网有机结合的“车、桩、网”智能充电系统配套的充电桩app系统的整体解决方案。"
          }
        },
        {
          path: "/crmManage",
          name: "crmManage",
          component: () => import("@/view/crmManage/index"),
          meta: {
            show: true,
            title: "CRM管理解决方案",
            typeId: "2",
            name:
              "CRM系统丨客户关系管理系统丨MetaCRM|客户关系管理系统/销售管理「深圳市物网通科技有限公司」",
            keywords: "CRM系统",
            description:
              "深圳市物网通科技有限公司是CRM专业厂商和客户关系管理专家,MetaCRM是一款智能平台化CRM软件,通过提升企业管理和协同办公,全面提高企业管理水平和运营效率,帮助企业实现卓越管理，可提供CRM个性化需求解决方案。"
          }
        },
        {
          path: "/erpManage",
          name: "erpManage",
          component: () => import("@/view/erpManage/index"),
          meta: {
            show: true,
            title: "智能制造ERP解决方案",
            typeId: "2",
            name:
              "深圳ERP_ERP系统_进销存软件|生产管理系统_进销存软件-erp管理软件-专业服装管理系统-仓储RFID系统「深圳市物网通科技有限公司」",
            keywords: "erp系统",
            description:
              "深圳市物网通科技有限公司高科技ERP系统研发公司,专业从事企业ERP系统,进销存软件,服装ERP进销存管理系统,仓库管理系统,出入库管理系统软件,仓储,采购管理,生产计划管理，管理软件研发和解决方案."
          }
        },
        {
          path: "/sapManage",
          name: "sapManage",
          component: () => import("@/view/sapManage/index"),
          meta: {
            show: true,
            title: "SAP智能解决方案",
            typeId: "2",
            name:
              "SAP ERP管理系统｜SAP软件:SAP S/4HANA, SAP Business byDesign, SAP Business One | MTC, SAP系统金牌代理 ERP软件实施  SAP广东「深圳市物网通科技有限公司」",
            keywords: "SAP系统",
            description:
              "深圳市物网通科技有限公司提供领先的ERP、云ERP、CRM、sap、大数据、云计算、供应链、物联网解决方案供应商，助您实现智造转型，让企业化繁为简."
          }
        },
        {
          path: "/smartSolution",
          name: "smartSolution",
          component: () => import("@/view/smartSolution/index"),
          meta: {
            show: true,
            title: "物联网智能解决方案",
            typeId: "2",
            name: "物联网智能解决方案「深圳市物网通科技有限公司」"
          }
        },
        {
          path: "/smartTram",
          name: "smartTram",
          component: () => import("@/view/smartTram/index"),
          meta: {
            show: true,
            title: "智能电动车解决方案",
            typeId: "2",
            name: "智能电动车中控，电动车智能化解决方案「深圳市物网通科技有限公司」",
            keywords: "智能电动车",
            description:
              "我们将提供整套解决方案，为智能硬件功能：智能防盗、感应加解锁、一键启动、远程控制、一键开关座舱锁、智能报警、车况自检、电量检测、续航里程预估、超速报警、断电报警、震动报警、智能语音、一键寻车、车辆授权等，整套方案集App+位置大数据+数据采集+云储存组成。"
          }
        },
        {
          path: "/powerBank",
          name: "powerBank",
          component: () => import("@/view/powerBank/index"),
          meta: {
            show: true,
            title: "共享充电宝",
            typeId: "1",
            name:
              "扫码共享充电宝_软件小程序_系统APP共享充电宝一站式解决方案可提供定制开发「深圳市物网通科技有限公司」",
            keywords: "共享充电宝",
            description:
              "深圳市物网通科技有限公司是一家国内领先的软件技术开发公司，坐落于科技创新之城深圳市，成熟的解决方案，共享充电宝后台开发定制，软硬件一体化、代理、加盟、共享充电宝一站式解决方案，共享系统开发物联网定制开发等，面向国内外服务广大用户。"
          }
        },
        {
          path: "/systemExploit",
          name: "systemExploit",
          component: () => import("@/view/systemExploit/index"),
          meta: {
            show: true,
            title: "系统开发",
            typeId: "3",
            name:
              "系统开发_软件定制_服务端开发_国内软件开发服务商「深圳市物网通科技有限公司」",
            keywords: "系统开发",
            description:
              "深圳市物网通科技有限公司是一家互联网综合信息服务提供商、是国内领先的系统开发服务商，金融软件，办公软件,ERP,CRM,ERP,OA办公系统，系统定制开发服务给各行业客户提供外包服务。"
          }
        },
        {
          path: "/appExploit",
          name: "appExploit",
          component: () => import("@/view/appExploit/index"),
          meta: {
            show: true,
            title: "移动APP软件开发",
            typeId: "3",
            name:
              "app开发_手机app开发_是国内app软件开发服务商致力于打造帮助传统企业实现互联网+转型_您的互联网转型合伙人「深圳市物网通科技有限公司」",
            keywords: "APP开发",
            description:
              "深圳市物网通科技有限公司是一家专业从事移动互联网开发公司,是家专业的APP开发公司,提供专业APP软件开发服务,其中包括app定制,手机软件开发,app开发报价,以及app开发流程,拥有专业的APP外包开发团队,承接APP软件外包业务,欢迎广大新老客户前来洽谈,开发服务电话:18123617975"
          }
        },
        {
          path: "/applets",
          name: "applets",
          component: () => import("@/view/applets/index"),
          meta: {
            show: true,
            title: "小程序开发",
            typeId: "3",
            name:
              "小程序开发_微信小程序_支付宝小程序_是国内小程序件开发服务商_您的互联网转型合伙人「深圳市物网通科技有限公司」",
            keywords: "小程序开发",
            description:
              "深圳市物网通科技有限公司是一家互联网综合信息服务提供商、提供微信公众号开发、微信小程序开发、智能硬件小程序开发、微信分销系统开发、网站开发建设、H5页面制作、系统软件开发服务、提供微信营销系统、电商分销系统、小程序专业开发及全行业解决方案。「深圳市物网通科技有限公司」"
          }
        },
        {
          path: "/noPublic",
          name: "noPublic",
          component: () => import("@/view/noPublic/index"),
          meta: {
            show: true,
            title: "微信公众号二次开发",
            typeId: "3",
            name:
              "公众号开发_微信公众号开发_国内微信公众号开发服务商「深圳市物网通科技有限公司」",
            keywords: "微信公众号开发",
            description:
              "深圳市物网通科技有限公司是一家互联网综合信息服务提供商、是国内领先的微信公众号二次开发平台、微信公众号定制开发，微信商城、小游戏、抽奖、预约、答题 ，为各行业客户提供外包服务。"
          }
        },
        {
          path: "/customMade",
          name: "customMade",
          component: () => import("@/view/customMade/index"),
          meta: {
            show: true,
            title: "物联网应用定制",
            typeId: "4",
            name: "物联网软件平台应用定制「深圳市物网通科技有限公司」",
            keywords: "物联网软件",
            description:
              "深圳市物网通科技有限公司是一家创新技术拥有先进物联网平台利用局部网络或互联网等通信技术把传感器、控制器、机器、人员和物等通过新的方式联在一起，形成人与物、物与物相联，实现信息化、远程管理控制和智能化的网络平台。提供定制服务。"
          }
        },
        {
          path: "/sharingEconomy",
          name: "sharingEconomy",
          component: () => import("@/view/sharingEconomy/index"),
          meta: {
            show: true,
            title: "共享经济解决方案",
            typeId: "4",
            name: "物联网软件平台应用定制「深圳市物网通科技有限公司」",
            keywords: "物联网软件",
            description:
              "深圳市物网通科技有限公司是一家创新技术拥有先进物联网平台利用局部网络或互联网等通信技术把传感器、控制器、机器、人员和物等通过新的方式联在一起，形成人与物、物与物相联，实现信息化、远程管理控制和智能化的网络平台。提供定制服务。"
          }
        },
        {
          path: "/smartLock",
          name: "smartLock",
          component: () => import("@/view/smartLock/index"),
          meta: {
            show: true,
            title: "智能锁解决方案",
            typeId: "4",
            name: "智能锁解决方案「深圳市物网通科技有限公司」",
            keywords: "物料包装设计",
            description:
              "深圳市物网通科技有限公司是一家基于物联云实现设备管理和数据采集、存储，解决海量连接和高并发难题。采用中移标准化方案板和中移和物APP，帮助智能门锁企业降低开发成本，大幅缩短开发周期，快速生成自己的智能化产品，抢占市场先机。 中移物联网有限公司提供多种高中低档、功能组合的方案，以满足个性化产品需求。向客户提供中移和物Saas和APP，一站式解决门锁厂家智能化难题。"
          }
        },
        {
          path: "/IPOCloud",
          name: "IPOCloud",
          component: () => import("@/view/IPOCloud/index"),
          meta: {
            show: true,
            title: "物联网IOT云平台",
            typeId: "4",
            name:
              "领先的物联网解决方案|物联网iot云平台|一站式智能硬件开发平台|提供物联网产品软硬件定制服务「深圳市物网通科技有限公司」",
            keywords: "物联网解决方案",
            description:
              "深圳市物网通科技有限公司拥有领先的物联网解决方案商，帮助企业和中小团队将产品快速智能化，并提供智能硬件开发外包和物联网软硬件定制服务。典型案例包括智能家居、智能家电、物联网传感云、共享经济、智能工业等行业。为北京、上海、深圳、广州、成都、长沙等城市提供智能硬件解决方案、物联网解决方案、智能硬件方案定制等服务，是国内领先的物联网解决方案公司。"
          }
        },
        {
          path: "/visualExperience",
          name: "visualExperience",
          component: () => import("@/view/visualExperience/index"),
          meta: {
            show: true,
            title: "视觉体验",
            typeId: "5",
            name: "视觉体验_页面体验设计「深圳市物网通科技有限公司」",
            keywords: "视觉设计",
            description:
              "我们对于客户的洞察之中 专注企业网站设计，营销型网站设计，响应式网站设计，品牌网站设计，用心完成每一个作品是时代创信的基本功，可以让整体的视觉效果,能够很好的提升产品的视觉体验,构造良好的用户体验。「深圳市物网通科技有限公司」"
          }
        },
        {
          path: "/websiteDesign",
          name: "websiteDesign",
          component: () => import("@/view/websiteDesign/index"),
          meta: {
            show: true,
            title: "网站设计",
            typeId: "5",
            name:
              "深圳网站设计公司_高端企业网站建设_专业网页设计公司「深圳市物网通科技有限公司」",
            keywords: "网站设计",
            description:
              "专注高端网站设计定制，服务包含高端网站策划设计、品牌网站设计、企业官网设计、集团网站设计公司、金融行业网站设计、P2P网站设计公司、深圳UI设计公司。我们是一家专业的品牌全案策划设计公司，为企业客户提供一站式网站解决方案。"
          }
        },
        {
          path: "/mobileDesign",
          name: "mobileDesign",
          component: () => import("@/view/mobileDesign/index"),
          meta: {
            show: true,
            title: "移动端设计",
            typeId: "5",
            name:
              "app设计_手机网站设计_手机网页设计_设计网站_「深圳市物网通科技有限公司」",
            keywords: "app设计",
            description:
              "深圳市物网通科技有限公司是定制服务商专业从事Android和ios app设计和开发,提供手机网站设计,app设计,手机ui设计,软件ui设计,小程序设计等服务；为客户提供互联网全案一站式服务.，"
          }
        },
        {
          path: "/systemDesign",
          name: "systemDesign",
          component: () => import("@/view/systemDesign/index"),
          meta: {
            show: true,
            title: "系统平台设计",
            typeId: "5",
            name:
              "系统平台设计|系统UI设计|网站设计平台设计|互联网定制服务商「深圳市物网通科技有限公司」",
            keywords: "系统平台设计",
            description:
              "深圳市物网通科技有限公司是一家互联网定制服务商，拥有成熟的系统平台设计、系统平台搭建团队，专注于为企业提供很佳的系统设计,平台设计,网站设计,大数据平台设计,管理系统设计等；全方面解决方案和服务."
          }
        },
        {
          path: "/brandDesign",
          name: "brandDesign",
          component: () => import("@/view/brandDesign/index"),
          meta: {
            show: true,
            title: "品牌设计",
            typeId: "5",
            name: "品牌设计_形象设计_vi设计_「深圳市物网通科技有限公司」",
            keywords: "vi设计",
            description:
              "深圳市物网通科技有限公司是一家互联网定制服务商主要为企业提供品牌设计,VI设计,形象设计,网站设计,LOGO设计,vi设计,标志设计,商标设计设计等,坚持以营销的理念做设计,多方面打造客户独特品牌形象"
          }
        },
        {
          path: "/packageDesign",
          name: "packageDesign",
          component: () => import("@/view/packageDesign/index"),
          meta: {
            show: true,
            title: "物料包装设计",
            typeId: "5",
            name: "包装设计_产品设计_画册设计_平面|包装「深圳市物网通科技有限公司」",
            keywords: "物料包装设计",
            description:
              "「深圳市物网通科技有限公司」是一家互联网服务商提供多方面形象设计服务,业务包含包装设计,产品设计,画册设计,宣传册设计,广告物料设计,标志设计等,为企业品牌提供一站式企业形象解决方案"
          }
        },
        {
          path: "/scenicSpot",
          name: "scenicSpot",
          component: () => import("@/view/scenicSpot/index"),
          meta: {
            show: true,
            title: "景区出行",
            typeId: "1",
            name:
              "智慧景区出行，景区单车租赁系统服务商，一站式解决方案「深圳市物网通科技有限公司」",
            keywords: "智慧景区，智慧出行",
            description:
              "智慧景区解决方案，基于大数据、AI、识别等能力，为景区提供具有导游导览，景区智慧出行，线路推荐，综合管控平台，大数据等功能的一体化智慧景区解决方案。「深圳市物网通科技有限公司」"
          }
        },
        {
          path: "/publicBicycles",
          name: "publicBicycles",
          component: () => import("@/view/publicBicycles/index"),
          meta: {
            show: false,
            title: "公共自行车解决方案",
            typeId: "1",
            name:
              "公共自行车解决方案_专注公共自行车系统解决方案「深圳市物网通科技有限公司」",
            keywords: "共享单车解决方案",
            description:
              "公共自行车 公共自行车旨在为进一步倡导“绿色、低碳、环保”出行方式,满足群众的出行需要，租车把卡放到上面读一下，锁就开了，自行车就可以骑走了；骑到任何一个其它租赁点都可以还车，因为系统是联网的，公共自行车将使用最新的物联网技术，来对整个公共自行车租用系统进行智能化管理，各自行车站点真正实现24小时无人值守和通借通还功能，调度管理中心实时监控和调度各站点的使用状态，我们将提供一站式整体解决方案。「深圳市物网通科技有限公司」"
          }
        },
        {
          path: "/newBicycle",
          name: "newBicycle",
          component: () => import("@/view/newBicycle/index"),
          meta: {
            show: false,
            title: "新型公共自行车解决方案",
            typeId: "1",
            name:
              "新型公共自行车,共享单车APP开发,共享单车小程序开发整体解决方案「深圳市物网通科技有限公司」",
            keywords: "共享单车APP开发",
            description:
              "共享单车 专业提供共享单车出行整体解决方案，有共享单车,共享电动单车,共享电动车,公共自行车,公共单车等方案，让骑行从共享开“驶”，提高共享单车运营管理效率，为国内外30多个城市提供优质整体解决方案，我们将提供一站式整体解决方案。「深圳市物网通科技有限公司」"
          }
        },
        {
          path: "/gpsLock",
          name: "gpsLock",
          component: () => import("@/view/gpsLock/index"),
          meta: {
            show: false,
            title: "GPS智能锁",
            typeId: "1",
            name:
              "共享单车智能锁,共享单车物联锁,智能物联锁,自行车智能锁,单车物联锁，定位锁「深圳市物网通科技有限公司」",
            keywords: "共享单车解决方案",
            description:
              "共享单车智能锁 专业提供共享单车出行整体解决方案，专业提供GPS智能锁、蓝牙锁等共享单车智能锁定制服务，其开发应用的共享单车物联锁、自行车智能锁，产品性能稳定，实时定位精准，超强续航能力，助力共享单车可视化运维管理，我们将提供一站式整体解决方案。「深圳市物网通科技有限公司」"
          }
        },
        {
          path: "/scenicBicycle",
          name: "scenicBicycle",
          component: () => import("@/view/scenicBicycle/index"),
          meta: {
            show: false,
            title: "景区单车解决方案01",
            typeId: "1",
            name:
              "景区共享单车，智能蓝牙锁，景区观光车，旅游景区整体解决方案「深圳市物网通科技有限公司」",
            keywords: "智慧景区，智慧出行",
            description:
              "智慧景区，景区单车、多人车、电单车、电动四轮车一站式共享方案解决服务商：配备智能3合1马蹄锁/ECU控制系统，采用蓝牙道钉定点取还车，真正解决景区车辆乱停乱放难题；各类小程序、成熟后台管理省去您开发成本，智慧景区快速实现无人租赁！「深圳市物网通科技有限公司」"
          }
        },
        {
          path: "/scenicBicycle2",
          name: "scenicBicycle2",
          component: () => import("@/view/scenicBicycle2/index"),
          meta: {
            show: false,
            title: "景区单车解决方案02",
            typeId: "1",
            name:
              "gps+gprs智能单车锁，景区共享单车，景区出行整体解决方案「深圳市物网通科技有限公司」",
            keywords: "智能单车锁",
            description:
              "智慧景区，景区单车、多人车、电单车、电动四轮车一站式共享方案解决服务商：配备智能3合1马蹄锁/ECU控制系统，采用蓝牙道钉定点取还车，智能锁有报警器功能、位置查询功能、记录功能的新型智能锁，成熟后台管理省去您开发成本「深圳市物网通科技有限公司」"
          }
        },
        {
          path: "/scenicElectricVehicle",
          name: "scenicElectricVehicle",
          component: () => import("@/view/scenicElectricVehicle/index"),
          meta: {
            show: false,
            title: "景区电动车解决方案",
            typeId: "1",
            name:
              "景区电动车，iot智能硬件+app景区出行整体解决方案「深圳市物网通科技有限公司」",
            keywords: "景区电动车",
            description:
              "多人车、双人电动车，电动四轮车，电动车或观光代步车,供游客租借骑行,按照传统的租借模式,用户需要到指定地方，我们将提供一站式共享方案解决方案，采用的是智能电控系统，采用蓝牙道钉定点取还车，智能断电控制器有报警器功能、位置查询功能、记录功能的新型智能控制器，成熟后台管理省去您开发成本「深圳市物网通科技有限公司」"
          }
        },
        {
          path: "/scenicSightseeingCar",
          name: "scenicSightseeingCar",
          component: () => import("@/view/scenicSightseeingCar/index"),
          meta: {
            show: false,
            title: "景区观光车解决方案",
            typeId: "1",
            name:
              "景区观光车，景区代步车iot智能硬件+app景区共享经济整体解决方案「深圳市物网通科技有限公司」",
            keywords: "景区观光车",
            description:
              "景区共享电动观光车系统是基于物联网技术，，实现无人租赁，我们将提供一站式共享方案解决方案：电控系统，采用蓝牙道钉定点取还车，智能断电控制器有报警器功能、位置查询功能、记录功能的新型智能控制器，成熟后台管理省去您开发成本「深圳市物网通科技有限公司」"
          }
        }
      ]
    }
  ]
});
router.beforeEach((to, from, next) => {
  //路由拦截器
  sessionStorage.setItem("typeId", to.meta.typeId);
  document.title = to.meta.name;
  document.getElementById("keywords").content = to.meta.keywords;
  document.getElementById("description").content = to.meta.description;
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js